import { NavLink } from 'react-router-dom';
import { Icon } from '../ui';
import type { IconName } from '../ui';
import styles from './Sidebar.module.css';

export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

interface SidebarProps {
  navItems: NavItem[];
  userDisplayName: string;
  /**
   * What `userDisplayName` IS — "Provider record" or "Signed in as". Optional:
   * AdminShell passes none and the caption simply does not render, because an
   * internal user's Entra name is the right name there and needs no label.
   *
   * It exists because an UNLABELLED name is the ISS-032 confounder: the AP
   * sidebar read the Entra guest name `ZZTest_AP_Andy` while the app had
   * resolved `ZA-001`, and nothing on screen said which fact was on show.
   */
  userDisplayCaption?: string;
  onLogout: () => void;
}

export default function Sidebar({
  navItems,
  userDisplayName,
  userDisplayCaption,
  onLogout,
}: SidebarProps) {
  return (
    <aside className={styles.sidebar}>
      {/* Brand */}
      <div className={styles.brand}>
        <img
          src="/logos/harmony-flower.png"
          alt="Harmony Homecare"
          className={styles.logo}
        />
      </div>

      {/* Navigation */}
      <nav className={styles.nav}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/ap' || item.path === '/admin'}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
            }
          >
            <span className={styles.navIcon}><Icon name={item.icon as IconName} size={22} /></span>
            <span className={styles.navLabel}>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className={styles.userSection}>
        {userDisplayCaption && (
          <span className={styles.userCaption}>{userDisplayCaption}</span>
        )}
        <span className={styles.userName} title={userDisplayName}>{userDisplayName}</span>
        <button
          className={styles.signOutButton}
          onClick={onLogout}
          type="button"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
